import { compositeIdFromName, isCompositeName } from './refs'
import { firebase_firestore } from '../../firebaseConfig'

type SideLike = { indicator?: { name?: string } } | undefined
type ConditionLike = { condition?: { LHS?: SideLike; RHS?: SideLike } }
type GroupLike = { conditions?: ConditionLike[]; conditionGroups?: GroupLike[] }
export type PatternLike = {
  buyConditionGroups?: GroupLike[]
  sellConditionGroups?: GroupLike[]
}

const collectFromSide = (side: SideLike, ids: Set<string>) => {
  const name = side?.indicator?.name
  if (isCompositeName(name)) ids.add(compositeIdFromName(name!))
}

const collectFromGroup = (group: GroupLike, ids: Set<string>) => {
  ;(group.conditions ?? []).forEach((c) => {
    collectFromSide(c.condition?.LHS, ids)
    collectFromSide(c.condition?.RHS, ids)
  })
  ;(group.conditionGroups ?? []).forEach((g) => collectFromGroup(g, ids))
}

/** Library ids of every custom indicator referenced anywhere in the pattern. */
export const collectCompositeIdsFromPattern = (pattern: PatternLike): Set<string> => {
  const ids = new Set<string>()
  ;[...(pattern.buyConditionGroups ?? []), ...(pattern.sellConditionGroups ?? [])].forEach((g) =>
    collectFromGroup(g, ids)
  )
  return ids
}

export const patternHasComposites = (pattern: PatternLike): boolean =>
  collectCompositeIdsFromPattern(pattern).size > 0

/** Shown wherever backtests/alerts are blocked for composite-bearing patterns. */
export const COMPOSITE_GATE_MESSAGE =
  "Custom indicators can't run in backtests or alerts yet — backend support is coming."

/**
 * Whether the composite backend gates should block this pattern. Gates are
 * PRODUCTION-ONLY: the dev backends (backtest functions + Go PDS) evaluate
 * composites, while prod awaits the gc-core develop-to-main promotion. Keyed
 * on the RESOLVED Firebase project (not the CRA env var) so the gate is
 * structurally tied to which backend the app actually talks to. Remove the
 * check entirely at the prod alert un-gate (gc-core#260 launch list).
 */
export const compositeGateActive = (pattern: unknown): boolean =>
  firebase_firestore.app.options.projectId === 'greenchart-93a2a' &&
  patternHasComposites(pattern as any)
